// ── StoreCard 공용 컴포넌트 — DetailSection + UnlinkBtn ──────────────────────
// StoreCard.jsx에서 분리. StoreCard + PcLeftPanel 등에서 공통 사용.

import React from 'react';
import { s } from './mobileStyles';
import { fmt } from './utils';

// ── DetailSection ─────────────────────────────────────────────────────────────
/** 계약차감·택배비 등 각 섹션의 헤더 + 합계 + 자식 행 렌더링 */
export function DetailSection({ label, total, color, sign, children }) {
  return (
    <div style={s.section}>
      <div style={s.secHeader}>
        <span style={s.secLabel}>{label}</span>
        <span style={{ ...s.secTotal, color }}>{sign}{fmt(total)}</span>
      </div>
      <div style={s.secBody}>{children}</div>
    </div>
  );
}

// ── UnlinkBtn ─────────────────────────────────────────────────────────────────
/** 연결된 결제 항목 해제 버튼 (× 아이콘) */
export function UnlinkBtn({ onClick }) {
  return (
    <button
      style={s.unlinkBtn}
      onClick={(e) => { e.stopPropagation(); onClick(); }}
      title="연결 해제"
    >
      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  );
}
